import { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Theme, Tooltip, useMediaQuery } from '@mui/material';
import {  CRUD_UPDATE, useMutation, useNotify, useRecordContext,useDataProvider, useRefresh} from 'react-admin';
import { BonusVoidModal } from './BonusVoidModal';
import { BonusChangePeriodModal } from './BonusChangePeriodModal';
import { DOWNLOAD_ICON, EDIT_ICON, TICK_ICON_FILLED } from '../../utils/Constants/ClassName';
import BonusDetailView from './BonusDetailView';
import ResponsiveDetailView from './ResponsiveDetailView';
import { PayBonusModal } from '../protivEmployeeBonusStatement/PayBonusModal';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import { PROPAY_STATUS } from '../../constants';
import { useQueryClient } from 'react-query';
import { USER_TYPE } from '../../utils/Constants/ConstantData';
import { BonusReverseModal } from './BonusReverseModal';
import LoadingSkeleton from '../../layout/LoadingSkeleton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ViewMergedRefModal from './ViewMergedRefModal';
import BonusResponsiveAdditionView from './BonusResponsiveAdditionView';

const BonusExpandedView = ({identity})=>{
    const record = useRecordContext();
    const [recordData,setRecordData]=useState<any>();
    const [isReload,setIsReload]=useState(true);
    const mergedData = {}
    useEffect(()=>{
        if(isReload){
                if(record?.child_bonus_statement_ids?.length > NUMBER.ZERO){
                    mergedData['id']= record.id;
                    mergedData['status']= record.status;
                    mergedData['number']= record.number;
                    mergedData['paid_period_id_obj']= record.paid_period_id_obj;
                    mergedData['statement_period_id_obj']= record.statement_period_id_obj;
                    mergedData['child_bonus_statement_ids']=record?.child_bonus_statement_ids;
                    mergedData['company_id_obj']=record.company_id_obj;
                    mergedData['normal_wage'] = record.normal_wage || NUMBER.ZERO;
                    mergedData['reserve_amount'] = record.reserve_amount || NUMBER.ZERO;
                    mergedData['total_earning'] = record.total_earning || NUMBER.ZERO;
                    mergedData['total_increased_wage'] = record.total_increased_wage || NUMBER.ZERO;
                    record?.child_bonus_statement_ids.forEach(item=>{ 
                        mergedData['propay_bonus_statement_ids']= mergedData['propay_bonus_statement_ids'] ? [...item.propay_bonus_statement_ids,...mergedData['propay_bonus_statement_ids']]:[...item.propay_bonus_statement_ids];
                        mergedData['void_propay_bonus_statement_ids']= mergedData['void_propay_bonus_statement_ids'] ? [...item.void_propay_bonus_statement_ids,...mergedData['void_propay_bonus_statement_ids']]:[...item.void_propay_bonus_statement_ids];
                    })
                    setRecordData(mergedData)
                }else{
                    setRecordData(record)
                } 
                setIsReload(!isReload);
            }
    },[isReload])
    return (<>
    {recordData ? <BonusStatementDetails setIsReload={setIsReload} identity={identity}  record={recordData} />:<LoadingSkeleton count={5} />}
    </>)
}

export const BonusStatementDetails = ({identity,record,setIsReload}) => {
    const [showVoidModal, setShowVoidModal] = useState(false);
    const [showChangeModal, setShowChangeModal] = useState(false);
    const [showPayModal,setShowModal]= useState(false);
    const [voidPropayId,setVoidPropayId]= useState(NUMBER.ZERO);
    const [bonusRecordId,setBonusRecordId]= useState(NUMBER.ZERO);
    const [propayName,setPropayName]= useState('');
    const [showMergeRefModal,setShowMergeRefModal]= useState(false);
    const [selectedRef,setSelectedRef]= useState(NUMBER.ZERO);
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const isOverageIncluded = record?.company_id_obj?.add_overage_cost_to_statement;
    const statementDataWithBonus = record?.propay_bonus_statement_ids?.filter(item=> !item?.deficit_amount && item.bonus_earning > NUMBER.ZERO && !item?.additional_pay_ids?.length);
    const statementsData = isOverageIncluded ? record?.propay_bonus_statement_ids?.filter(ele=>(ele.bonus_earning > NUMBER.ZERO || ele.overage_ids.length > NUMBER.ZERO ) && !ele?.additional_pay_ids?.length) : statementDataWithBonus;
    const additionalDetails = record?.propay_bonus_statement_ids?.filter(item=> item?.additional_pay_ids?.length > NUMBER.ZERO)
    const voidData = record?.void_propay_bonus_statement_ids;
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        });
        const [mutate] = useMutation();
        const notify = useNotify();
        const queryClient = useQueryClient();
        const [showReverseModal,setShowReverseModal]= useState(false);
        const [isOverage,setIsOverage]= useState(false);
        const refreshData=async()=>{ 
         await queryClient.invalidateQueries(['protivEmployeeBonusStatement', 'getList']);
            setIsReload(true);
        }
        const markPendingBonuses = (data)=>{
            return mutate(
                {
                    type: 'update',
                    resource: 'protivEmployeeBonusStatement',
                    payload: {ids:[data.id] , action:'pendingBonusStatement', data: {} }
                },
                {
                    mutationMode: 'pessimistic',
                    action: CRUD_UPDATE,
                    onSuccess: () => {
                        notify('Successfully! Statement marked as pending');
                        refreshData();
                        queryClient.invalidateQueries(['protivEmployeeBonusStatement', 'getList']);
                    },
                    onFailure: error => {
                        notify(`Failure ! ${error.message}`);
                    }
                }
                );
        }
        
    return (
        <>
       {isSmall ? <>
       <div className='bonus-statement-label'><strong>Statement Period :</strong> {record?.statement_period_id_obj?.display_name} </div>
       <div className='bonus-statement-label'><strong>Paid Period :</strong> {record?.paid_period_id ? record.paid_period_id_obj.display_name: '~'} </div>
       <div className='bonus-statement-label'><strong>Earnings :</strong> {formatter.format(record.total_earning)} </div>
        <div className="bonuses-download-parent">
            <div className="bonuses-download-row">
                {(record.status !== PROPAY_STATUS.PAID && identity?.user_type !== USER_TYPE.worker) &&
                    <Button className="bonus-close-btn" onClick={() => setShowModal(true)} disabled={!statementsData?.length && !voidData.length && !additionalDetails?.length}>Mark Close ({additionalDetails?.length > NUMBER.ZERO ? statementsData?.length+additionalDetails.length:statementsData?.length})</Button>
                }
                {(record.status !== PROPAY_STATUS.PENDING && identity?.user_type !== USER_TYPE.worker)&& <Button className="mark-as-pending-btn" onClick={() => markPendingBonuses(record)}>
                    {TICK_ICON_FILLED()}Mark as Pending</Button>}
            </div>
        </div>
        <div>
                  {statementsData?.length > NUMBER.ZERO &&  <ResponsiveDetailView
                        data={record}
                        detailData={statementsData}
                        total={statementsData?.length}
                        identity={identity}
                        setShowVoidModal={setShowVoidModal}
                        setShowChangeModal={setShowChangeModal}
                        setVoidPropayId={setVoidPropayId}
                        setBonusRecordId={setBonusRecordId}
                        isVoidSection={false}
                        setPropayName={setPropayName}
                        setShowReverseModal={setShowReverseModal}
                        setIsOverage={setIsOverage}     
                    />}
                     <BonusResponsiveAdditionView identity={identity} additionalDetails={additionalDetails} refreshData={refreshData}  data={record}/>
                    
                     {
               voidData.length > NUMBER.ZERO ? <div className='void-manager-bonus'>
                   <div className='void-manager-bonus-head'>Void</div>
                             <ResponsiveDetailView
                        data={record}
                        detailData={voidData}
                        total={voidData?.length}
                        identity={identity}
                        setShowVoidModal={setShowVoidModal}
                        setShowChangeModal={setShowChangeModal}
                        setShowReverseModal={setShowReverseModal}
                        isVoidSection={true}
                        setBonusRecordId={setBonusRecordId}
                        setVoidPropayId={setVoidPropayId}
                        setIsOverage={setIsOverage}
                    />
                        </div>:''
                    }
            </div>
       </>:
        <div className="bonuses-download-parent">
            <div className="bonuses-download-row">
                <div className='merge-ref-parent'>
                <div className='ref-no-statement'>
                Ref #: {record.number}
                </div>
                {record?.child_bonus_statement_ids?.length > NUMBER.ZERO ?  <Accordion className='merge-ref-accordion'> 
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="view-merged-ref-content"
                        id="view-merged-ref-header"
                    >
                       View merged ref
                    </AccordionSummary>
                    <AccordionDetails>
                       {record?.child_bonus_statement_ids.map(ele=>{return(
                           <Button  className='view-ref-content' onClick={()=>{setSelectedRef(ele.number);setShowMergeRefModal(true)}}>Ref #: {ele.number}</Button>
                             )})}
                    </AccordionDetails>
                </Accordion>:''}
                </div>
            
               {showMergeRefModal && <ViewMergedRefModal bonusData={record?.child_bonus_statement_ids.filter(el=>el.number === selectedRef)} identity={identity} selectedRef={selectedRef} isOpen={showMergeRefModal} handleClose={()=>setShowMergeRefModal(false)}></ViewMergedRefModal>}
                {/* <div className="bonus-download-link">
                    {DOWNLOAD_ICON()}
                    Download
                </div> */}
               {(record.status !== PROPAY_STATUS.PAID && identity?.user_type !== USER_TYPE.worker) && <Button className="bonus-close-btn" onClick={()=>setShowModal(true)} disabled={!statementsData?.length && !voidData.length && !additionalDetails?.length}>Mark Close ({additionalDetails?.length > NUMBER.ZERO ? statementsData?.length+additionalDetails.length:statementsData?.length})</Button>}
               {(record.status !== PROPAY_STATUS.PENDING && identity?.user_type !== USER_TYPE.worker) && <Button className="mark-as-pending-btn" onClick={()=>markPendingBonuses(record)}>
                {TICK_ICON_FILLED()}Mark as Pending</Button>}
           
            </div>
            <div>
                   {(statementsData?.length > NUMBER.ZERO || additionalDetails.length > NUMBER.ZERO) && <BonusDetailView
                        data={record}
                        detailData={statementsData}
                        total={statementsData?.length}
                        identity={identity}
                        setShowVoidModal={setShowVoidModal}
                        setShowChangeModal={setShowChangeModal}
                        setVoidPropayId={setVoidPropayId}
                        setBonusRecordId={setBonusRecordId}
                        isVoidSection={false}
                        setPropayName={setPropayName}
                        setShowReverseModal={setShowReverseModal}
                        setIsOverage={setIsOverage}
                        additionalDetails={additionalDetails}
                        refreshData={refreshData}
                        showAdditional={record.status !== PROPAY_STATUS.PAID ||  identity?.user_type !== USER_TYPE.worker}
                    />}
            </div>
            {
               voidData.length > NUMBER.ZERO ? <div className='void-manager-bonus'>
                   <div className='void-manager-bonus-head'>Void </div>
                             <BonusDetailView
                        data={record}
                        detailData={voidData}
                        total={voidData?.length}
                        identity={identity}
                        setShowVoidModal={setShowVoidModal}
                        setShowReverseModal={setShowReverseModal}
                        setShowChangeModal={setShowChangeModal}
                        isVoidSection={true}
                        setBonusRecordId={setBonusRecordId}
                        setVoidPropayId={setVoidPropayId}
                        setIsOverage={setIsOverage}
                        refreshData={refreshData}
                        showAdditional={!statementsData?.length && (record.status !== PROPAY_STATUS.PAID ||  identity?.user_type !== USER_TYPE.worker)}
                    />
                        </div>:''
                    }
        </div>}
       {showVoidModal ? <BonusVoidModal
                isOpen={showVoidModal}
                onClose={() => {setShowVoidModal(false);setIsOverage(false)}}
                propayId={voidPropayId}
                recordId={bonusRecordId}
                propayName={propayName}
                isOverage={isOverage}
                refreshData={refreshData}
            />:''}
           {showChangeModal ? <BonusChangePeriodModal
                isOpen={showChangeModal}
                onClose={() => setShowChangeModal(false)}
                recordId={bonusRecordId}
                statementId={record?.statement_period_id_obj?.id}
                refreshData={refreshData}
            />:''}
             {showPayModal ? <PayBonusModal
                isOpen={showPayModal}
                onClose={() => setShowModal(false)}
                recordIds={[record.id]}
                refreshData={refreshData}
            />:''}
           {showReverseModal ? <BonusReverseModal
                isOpen={showReverseModal}
                onClose={() => setShowReverseModal(false)}
                propayId={voidPropayId}
                recordId={bonusRecordId}
                refreshData={refreshData}
            />:''}
            
        </>
    );
};
export default BonusExpandedView;
